import cx from 'classnames';

import { Card } from './Card';
import { Avatar, Text, Phone, Email } from '../index';
import { getFullName, getInitials } from '../../utils/Profile/profile';
import { t } from '../../i18n';

interface CardContactProps {
  firstName?: string;
  lastName?: string;
  company?: string;
  companyId?: string;
  position?: string;
  phone?: string;
  email?: string;
  action?: JSX.Element;
  afterStart?: JSX.Element;
  beforeEnd?: JSX.Element;
  className?: string;
}

const getCompanyInitials = (company: string): string =>
  company
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() ?? '')
    .join('');

export const CardContact: React.FC<CardContactProps> = (props) => {
  const { firstName, lastName, company, companyId, position, phone, email } = props;

  const personName = getFullName(firstName, lastName);
  const hasCompany = Boolean(company);

  const primaryName = hasCompany ? company : personName;
  const initials = hasCompany ? getCompanyInitials(company!) : getInitials(firstName, lastName);

  // For company contacts: contact person + IČO line. For people: position (Předseda etc.).
  const secondaryParts = hasCompany
    ? [personName, companyId && `IČO ${companyId}`].filter(Boolean)
    : position
      ? [position]
      : [];
  const secondary = secondaryParts.join(' · ');

  return (
    <Card className={cx('CardContact', props.className)}>
      {props.afterStart}
      {initials && (
        <div className="CardContactAvatar">
          <Avatar initials={initials} size="large" />
        </div>
      )}

      <div className="CardContactContent">
        <div className="CardContactDetails">
          <Text size="body-medium" weight="600" color="Neutral700" className="CardContactName">
            {primaryName || t('Card.Contact.emptyFullName')}
          </Text>

          {secondary && (
            <Text size="body-small" weight="500" color="Neutral600" className="CardContactPosition">
              {secondary}
            </Text>
          )}
        </div>
        <div className="CardContactActions">
          {phone && <Phone number={phone} />}
          {email && <Email email={email} />}
          {props.action}
        </div>
      </div>
      {props.beforeEnd}
    </Card>
  );
};
